import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../globals';
import {CommonModule} from '@angular/common';
import {FormService} from '../services/FormService';
import {Checkbox} from 'primeng/checkbox';

declare var Yii: IYii;

@Component({
  selector: 'ng-form-editable-shared',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox
  ],
  template: `
    @if (nfsvc.form.type == 1) {
      <div class="form-row">
        <label>
          {{Yii.t('app', 'Is Editable after submitting')}}
        </label>
        <div>
          <p-checkbox
            binary="true"
            [(ngModel)]="nfsvc.form.is_editable_after_submitting"
            (ngModelChange)="onEditableChange()"
          />
        </div>
      </div>

      @if (nfsvc.form.is_editable_after_submitting) {
        <div class="form-row">
          <label>
            {{Yii.t('app', 'Shared Form')}}
          </label>
          <div>
            <p-checkbox
              binary="true"
              [(ngModel)]="nfsvc.form.shared_form"
            />
          </div>
        </div>
      }
    }
  `
})
export class FormEditableSharedComponent {
  Yii = Yii;

  constructor(public nfsvc: FormService) {}

  onEditableChange(): void {
    if (!this.nfsvc.form.is_editable_after_submitting) {
      this.nfsvc.form.shared_form = false;
    }
  }
}
